import { useToast } from '@cian/ui-kit';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks';
import { clearNotifications, selectNotifications } from '../../slices';

export function NotificationsContainer() {
  const dispatch = useAppDispatch();
  const toastApi = useToast();
  const notifications = useSelector(selectNotifications);

  useEffect(() => {
    if (!notifications.length) {
      return;
    }

    notifications.forEach(({ type, text }) => toastApi.open({ type, text }));

    dispatch(clearNotifications());
  }, [notifications, toastApi, dispatch]);

  return null;
}
